import {
  Box,
  Button,
  Chip,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useState,useMemo } from "react";
import {
  AttendenceUpdate,
  FetchBranchShowData,
  FetchClassTypeShowData,
  FetchSectionShowData,
  FetchSemesterShowData,
  FetchSpecializationShowData,
  GetAttendenceView,
  GetCourseShowData,
  GetSectionShowData,
  GetSemesterShowData,
  GetSpecializationShowData,
  GetSubject,
  GetSubjectShowData,
  LocationShowdata,
  SendBulkSms,
} from "../../services/LoginPageService";
import { jobStatusColor } from "../../utils/helperFunctions";
import AttendenceTools from "./AttendenceTools";
import BulkUpload from "./BulkUpload";
import { Checkbox } from "@mui/material";
const AttendenceList = () => {
  const [location, setLocation] = useState("");
  const [locationList, setLocationList] = useState([]);
  const [branch, setBranch] = useState("");
  const [branchList, setBranchList] = useState([]);
  const [specialization, setSpecialization] = useState("");
  const [specializationList, setSpecializationList] = useState([]);
  const [semester, setSemester] = useState("");
  const [semesterList, setSemesterList] = useState([]);
  const [section, setSection] = useState("");
  const [sectionList, setSectionList] = useState([]);
   const [subject, setSubject] = useState("");
  const [subjectList, setSubjectList] = useState([]);
const [rows, setRows] = useState([]);
  const [isAddButton, setIsAddButton] = useState(true);
  const [editClassName, setEditClassName] = useState("");
  const [open, setOpen] = useState(false);
  const [refreshData, setRefreshData] = useState(false);
 const [classTypedataList,setClassTypeDataList] = useState([])
          const [classType, setClassType] = useState('');
          const allChecked = rows.length > 0 && rows.every((row) => row.isSendSMS === 1);
const someChecked = rows.some((row) => row.isSendSMS === 1);
  // const columns = [
  //   {
  //     field: "date",
  //     headerName: "Date",
  //     headerClassName: "super-app-theme--header",
  //     minWidth: 100,
  //     flex: 1,
  //     align: "center",
  //     headerAlign: "center",
  //   },
  
  //   {
  //     field: "studentId",
  //     headerName: "Student Id",
  //     headerClassName: "super-app-theme--header",
  //     minWidth: 100,
  //     flex: 1,
  //     align: "center",
  //     headerAlign: "center",
  //   },
  //   {
  //     field: "studentName",
  //     headerName: "Name",
  //     headerClassName: "super-app-theme--header",
  //     minWidth: 100,
  //     flex: 1,
  //     align: "center",
  //     headerAlign: "center",
  //   },
  //   {
  //     field: "inTime",
  //     headerName: "Login Time",
  //     headerClassName: "super-app-theme--header",
  //     minWidth: 100,
  //     flex: 1,
  //     align: "center",
  //     headerAlign: "center",
  //   },
  //   // {
  //   //   field: "outTime",
  //   //   headerName: "Logout Time",
  //   //   headerClassName: "super-app-theme--header",
  //   //   minWidth: 100,
  //   //   flex: 1,
  //   //   align: "center",
  //   //   headerAlign: "center",
  //   // },
    
  //   {
  //     field: "status",
  //     headerName: "Status",
  //     headerClassName: "super-app-theme--header",
  //     minWidth: 100,
  //     flex: 1,
  //     align: "center",
  //     headerAlign: "center",
  //     sortable: false,
  //     cellClassname: "actions",
  //     type: "actions",
  //     getActions: (params) => [
  //       <Chip
  //         label={params.row.status}
  //         color={jobStatusColor(params.row.status)}
  //       />,
  //     ],
  //   },
  // ];


// ✅ Helper to check if all rows are selected
const isAllChecked = rows.length > 0 && rows.every(row => row.isSendSMS === "1");

// ✅ Helper to check if some rows are selected
const isIndeterminate =
  rows.some(row => row.isSendSMS === "1") && !isAllChecked;


const columns = [
  {
    field: "date",
    headerName: "Date",
    headerClassName: "super-app-theme--header",
    minWidth: 100,
    flex: 1,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "studentId",
    headerName: "Student Id",
    headerClassName: "super-app-theme--header",
    minWidth: 100,
    flex: 1,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "studentName",
    headerName: "Name",
    headerClassName: "super-app-theme--header",
    minWidth: 100,
    flex: 1,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "inTime",
    headerName: "Login Time",
    headerClassName: "super-app-theme--header",
    minWidth: 100,
    flex: 1,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "status",
    headerName: "Status",
    headerClassName: "super-app-theme--header",
    minWidth: 100,
    flex: 1,
    align: "center",
    headerAlign: "center",
    sortable: false,
    type: "actions",
    getActions: (params) => [
      <Chip
        label={params.row.status}
        color={jobStatusColor(params.row.status)}
      />,
    ],
  },
// {
//   field: "sendSMS",
//   headerName: "Send SMS",
//   headerClassName: "super-app-theme--header",
//   minWidth: 120,
//   flex: 1,
//   align: "center",
//   headerAlign: "center",
//   sortable: false,
//   renderCell: (params) => {
//     if (params.row.isSendSMS === null) {
//       return null; // no checkbox if null
//     }

//     return (
//       <Checkbox
//         checked={params.row.isSendSMS === 1}
//         onChange={(e) => {
//           const newValue = e.target.checked ? 1 : 0;

//           // 🔹 Build payload for API
//           const payload = {
//             isSMS: newValue,
//             date: params.row.date,
//             studentId: params.row.studentId,
//           };

//           console.log("Sending payload:", payload);

//           // 🔹 Call your API
//           AttendenceUpdate(
//             payload,
//             (res) => {
//               console.log("Update success:", res);

//               // update local state so UI matches server
//               // setRow((prevRows) =>
//               //   prevRows.map((row) =>
//               //     row.id === params.row.id
//               //       ? { ...row, isSendSMS: newValue.toString() }
//               //       : row
//               //   )
//               // );
//                GetAttendenceView(
//       {
//         location: location,
//         branch: branch,
//         specialization: specialization,
//         semester: semester,
//         // section: section,
//         // subject: subject,
//         // classType:classType,

//       },
//       handleAttendenceView,
//       handleAttendenceViewException
//     );
//             },
//             (err) => {
//               console.error("Update failed:", err);
//             }
//           );
//         }}
//       />
//     );
//   },
// }


{
  field: "sendSMS",
  headerName: "Send SMS",
  headerClassName: "super-app-theme--header",
  minWidth: 150,
  flex: 1,
  align: "center",
  headerAlign: "center",
  sortable: false,

  renderHeader: () => {
    const allChecked = rows.length > 0 && rows.every((r) => r.isSendSMS === 1);
    const someChecked = rows.some((r) => r.isSendSMS === 1);

    return (
      <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
        <span>Send SMS</span>
        <Checkbox
          size="small"
          indeterminate={!allChecked && someChecked}
          checked={allChecked}
          onChange={(e) => {
            const newValue = e.target.checked ? 1 : 0;

            // ✅ Update all rows locally
            const updatedRows = rows.map((r) => ({ ...r, isSendSMS: newValue }));
            setRows(updatedRows);

            // ✅ Call SendBulkSms API without date
            const payload = {
              location: location,     
              branch: branch,         
              specialization: specialization, 
              semester: semester,     
              isSMS: newValue         
            };

            console.log("Bulk SMS Payload:", payload);

            SendBulkSms(
              payload,
              (res) => {
                console.log("Bulk SMS success:", res);

                // optional: refresh rows from server
                GetAttendenceView(
                  { location, branch, specialization, semester },
                  handleAttendenceView,
                  handleAttendenceViewException
                );
              },
              (err) => {
                console.error("Bulk SMS failed:", err);
              }
            );
          }}
        />
      </div>
    );
  },

  renderCell: (params) => {
    if (params.row.isSendSMS === null) return null;

    return (
      <Checkbox
        checked={params.row.isSendSMS === 1}
        onChange={(e) => {
          const newValue = e.target.checked ? 1 : 0;

          // ✅ Update single row locally
          setRows(prev =>
            prev.map(r =>
              r.studentId === params.row.studentId
                ? { ...r, isSendSMS: newValue }
                : r
            )
          );

          // ✅ Single update API still includes date per row
          const payload = {
            isSMS: newValue,
            date: params.row.date,
            studentId: params.row.studentId
          };
          console.log("Single SMS Payload:", payload);

          AttendenceUpdate(
            payload,
            (res) => {
              console.log("Update success:", res);
              GetAttendenceView(
                { location, branch, specialization, semester },
                handleAttendenceView,
                handleAttendenceViewException
              );
            },
            (err) => {
              console.error("Update failed:", err);
            }
          );
        }}
      />
    );
  },
}

];


  useEffect(() => {
    LocationShowdata(handleLocationshow, handleLocationshowException);
         FetchClassTypeShowData(handleTypeSuccess, handleTypeException );
    
  }, [refreshData]);

  const handleLocationshow = (dataObject) => {
    setLocationList(dataObject?.data);
    console.log(dataObject?.data);
  };

  const handleLocationshowException = (error, errorMessage) => {
    console.log(errorMessage);
  };
const handleTypeSuccess=(dataObject)=>{
setClassTypeDataList(dataObject.data)
}

const handleTypeException=()=>{

}

  const handleFetchSuccess = (dataObject) => {
        setBranchList(dataObject.data);
    }

    const handleFetchException = (errorStaus, errorMessage) => {
        console.log(errorMessage);
    }



  const onLocationChange = (e) => {
    setLocation(e.target.value);
     FetchBranchShowData (
      { id: e.target.value },
      handleBranchSuccess,
      handleBranchException
    );
  };

  const handleBranchSuccess = (dataObject) => {
    setBranchList(dataObject.data);
  };

  const handleBranchException = (errorStaus, errorMessage) => {
    console.log(errorMessage);
  };

  const onBranchChange = (e) => {
    setBranch(e.target.value);
    FetchSpecializationShowData(
      { id: e.target.value },
      handleSpecializationSuccess,
      handleSpecializationException
    );
  };

  const handleSpecializationSuccess = (dataObject) => {
    setSpecializationList(dataObject.data);
  };

  const handleSpecializationException = (errorStaus, errorMessage) => {
    console.log(errorMessage);
  };

  const handleSemesterSuccess = (dataObject) => {
    setSemesterList(dataObject.data);
  };

  const handleSemesterException = (errorStaus, errorMessage) => {
    console.log(errorMessage);
  };

  const onSpecializationChange = (e) => {
    setSpecialization(e.target.value);
    FetchSemesterShowData(
      { id: e.target.value },
      handleSemesterSuccess,
      handleSemesterException
    );
  };

 
  const onSemesterChange = (e) => {
  const selectedSemesterId = e.target.value;
  setSemester(selectedSemesterId);
console.log("..............>>>>>>>>>>",selectedSemesterId)
  // Call API to fetch sections
  FetchSectionShowData(
    { id: selectedSemesterId },
    handleSectionSuccess,
    handleSectionException
  )
   GetSubject(
      { id: e.target.value },
      handleSubjectSuccess,
      handleSubjectException
    );

};


  const handleSectionSuccess = (dataObject) => {
    setSectionList(dataObject.data);
    
    
  };

  const handleSectionException = (errorStaus, errorMessage) => {
    console.log(errorMessage);
  };

  // const onSectionChange = (e) => {
  //   setSection(e.target.value);
  //   GetSubjectShowData(
  //   { id: e.target.value },
  //   handleSubjectSuccess,
  //   handleSubjectException
  // );
    
  // };
  
  const onSectionChange = (e) => {
    setSection(e.target.value);
   
  };

  const  handleSubjectSuccess = (dataObject) => {
    setSubjectList(dataObject?.data);
  };

  const handleSubjectException = (errorStaus, errorMessage) => {
    console.log(errorMessage);
  };

  const onSubjectChange = (e) => {
    setSubject(e.target.value);
  };

  const OnBulk = () => {
    setOpen(true);
  };
const onClassTypeChange =(e)=>{
            setClassType(e.target.value);
            // onclassTypeChange(e.target.value);
    }
  const onViewData = () => {
    GetAttendenceView(
      {
        location: location,
        branch: branch,
        specialization: specialization,
        semester: semester,
        // section: section,
        // subject: subject,
        // classType:classType,

      },
      handleAttendenceView,
      handleAttendenceViewException
    );
  };

  const handleAttendenceView = (dataObject) => {
    setRows(dataObject?.data);
    // ClearForm();
  };

  const ClearForm = () => {
    setSection("");
    setSemester("");
  };

  const handleAttendenceViewException = (errorStaus, errorMessage) => {
    console.log(errorMessage);
  };

  return (
    <div
      style={{
        height: 580,
        width: "98%",
        marginLeft: "20px",
        marginTop: "10px",
        overflow: "scroll",
      }}
    >
      <AttendenceTools
        setIsAddButton={setIsAddButton}
        editClassName={editClassName}
        setEditClassName={setEditClassName}
      />
      <Grid container spacing={3}>
        <Grid item xs={12} sm={2.5} md={2.5} lg={2.5} xl={2.5} style={{}}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              Select Location
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="Select Location"
              placeholder="Select Location"
              required
              value={location}
              onChange={(e) => onLocationChange(e)}
            >
              {locationList?.map((data, index) => {
                return (
                  <MenuItem value={data.id} key={index}>
                    {data.location}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={2} md={2} lg={2} xl={2} style={{}}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Select Hostel Name</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="Select Hostel Name"
              placeholder="Select Hostel Name"
              required
              value={branch}
              onChange={(e) => onBranchChange(e)}
            >
              {branchList.length !== 0 ? (
                <MenuItem value="" key={0}>
                  <em>Select Hostel Name</em>
                </MenuItem>
              ) : (
                <MenuItem value="" key={0}>
                  <em>Select Location </em>
                </MenuItem>
              )}
              {branchList?.map((data, index) => {
                return (
                  <MenuItem value={data.id} key={index}>
                    {data.branch}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={2} md={2} lg={2} xl={2} style={{}}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              Specialization
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="Specialization"
              placeholder="Specialization"
              value={specialization}
              required
              onChange={(e) => onSpecializationChange(e)}
            >
              {specializationList.length !== 0 ? (
                <MenuItem value="" key={0}>
                  <em>Select Specialization</em>
                </MenuItem>
              ) : (
                <MenuItem value="" key={0}>
                  <em>Select Hostel Name </em>
                </MenuItem>
              )}
              {specializationList?.map((data, index) => {
                return (
                  <MenuItem value={data.id} key={index}>
                    {data.specialization}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={2} md={2} lg={2} xl={2} style={{}}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              Select Year
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="Select Year"
              placeholder="Select Year"
              required
              value={semester}
              onChange={(e) => onSemesterChange(e)}
            >
              {semesterList.length !== 0 ? (
                <MenuItem value="" key={0}>
                  <em>Select Year</em>
                </MenuItem>
              ) : (
                <MenuItem value="" key={0}>
                  <em>Select Specialization </em>
                </MenuItem>
              )}
              {semesterList?.map((data, index) => {
                return (
                  <MenuItem value={data.id} key={index}>
                    {data.semester}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>
   
        <Grid item xs={12} sm={1} md={1} lg={1} xl={1} style={{}}>
          <Button variant="contained" onClick={onViewData}>
            View
          </Button>
        </Grid>
      </Grid>
      <Grid style={{ marginTop: "20px" }}>
     
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={10}
          rowsPerPageOptions={[10, 20, 50]}
          disableSelectionOnClick
          sx={{
            height: 400, // 👈 Fixed height triggers internal scroll
            width: "100%",
            "& .super-app-theme--header": {
              WebkitTextStrokeWidth: "0.6px",
            },
            "& .MuiDataGrid-virtualScroller": {
              overflowY: "scroll", // 👈 Force scroll always visible
            },
            "& .MuiDataGrid-main": {
              scrollbarWidth: "thin", // For Firefox
            },
            "& ::-webkit-scrollbar": {
              width: "8px", // For Chrome & Edge
            },
            "& ::-webkit-scrollbar-thumb": {
              backgroundColor: "#c1c1c1", // Thumb color
              borderRadius: "4px",
            },
            "& ::-webkit-scrollbar-track": {
              backgroundColor: "#f5f5f5", // Track color
            },
          }}
        />
      </Grid>
      <BulkUpload
        setOpen={setOpen}
        setRefreshData={setRefreshData}
        open={open}
      />
    </div>
  );
};

export default AttendenceList;
